export default {"src":"/_next/static/media/greenonions.aa5c014f.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};